import { ACCOUNT_LOCKED } from 'containers/SignupPages/constants';
import { translate } from 'helpers/intl';
import { isDrpp, isNumAdhesion } from 'utils/amcUtils';
import messages from './messages';

export interface FormValues {
  password: string;
  identifiant: string;
  isSaveUserId: boolean;
  hasAmc: boolean;
  organization: any;
  drpp: string;
  membershipNumber: string;
  cin: string;
}

export const formatValues = ({
  organization,
  membershipNumber,
  drpp,
  cin,
  hasAmc,
  ...values
}: FormValues) => ({
  ...values,
  hasAmc,
  ...(hasAmc &&
    organization && {
      organisme: organization.policyNumber,
      drpp: isDrpp(organization?.isdrpp) ? drpp : '',
      numAdhesion: isNumAdhesion(
        organization?.numAdhesion,
        organization?.isdrpp,
      )
        ? membershipNumber
        : '',
      cin:
        !isNumAdhesion(organization?.numAdhesion, organization?.isdrpp) &&
        !isDrpp(organization?.isdrpp)
          ? cin
          : '',
    }),
});

export const constructErrorMessage = (
  responseErrorMessage: any | undefined,
  props: any,
): string => {
  if (responseErrorMessage?.error === ACCOUNT_LOCKED) {
    const { time_value } = responseErrorMessage.data;
    return `${translate(
      messages.accountLocked,
      props,
    )} ${time_value} ${translate(messages.minutes, props)}`;
  }
  return translate(messages.loginError, props);
};
